/**
 * MOQ (custom.moq) helpers for product.single-product-new template only.
 * Expects window.__MOQ_VARIANT_MAP = { [variantId]: number }
 * min = MOQ, step = 1 (free increment / manual input above MOQ)
 */
(function () {
  const map = window.__MOQ_VARIANT_MAP || {};

  function getMoq(variantId) {
    const raw = map[String(variantId)];
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? Math.floor(n) : 1;
  }

  function getProductForm() {
    return document.querySelector('product-form-component form[data-type="add-to-cart-form"]');
  }

  function getVariantId(form) {
    const input = form?.querySelector('input[name="id"]');
    return input ? String(input.value) : '';
  }

  function getQuantityInput(form) {
    return form?.querySelector('quantity-selector-component input[ref="quantityInput"], input[name="quantity"]');
  }

  function applyMoqToQuantity(form, moq, resetValue) {
    const qtyInput = getQuantityInput(form);
    if (!qtyInput) return;

    qtyInput.min = String(moq);
    qtyInput.step = '1';
    qtyInput.setAttribute('data-min', String(moq));
    qtyInput.setAttribute('data-moq', String(moq));

    const selector = qtyInput.closest('quantity-selector-component');
    if (selector && typeof selector.updateConstraints === 'function') {
      selector.updateConstraints(String(moq), qtyInput.max || null, '1');
      if (resetValue) selector.setValue(String(moq));
    } else if (resetValue) {
      qtyInput.value = String(moq);
    } else {
      let val = parseInt(qtyInput.value, 10) || moq;
      if (val < moq) val = moq;
      qtyInput.value = String(val);
    }

    const productForm = form.closest('product-form-component');
    if (productForm) productForm.dataset.quantityDefault = String(moq);
  }

  function syncFromCurrentVariant(resetValue) {
    const form = getProductForm();
    if (!form) return;
    const moq = getMoq(getVariantId(form));
    applyMoqToQuantity(form, moq, resetValue);
  }

  function validateBeforeAdd(event) {
    const form = getProductForm();
    if (!form) return;

    const moq = getMoq(getVariantId(form));
    const qtyInput = getQuantityInput(form);
    const qty = parseInt(qtyInput?.value || '0', 10) || 0;

    if (qty < moq) {
      event.preventDefault();
      event.stopImmediatePropagation();
      alert(`Minimum order quantity is ${moq}.`);
      if (qtyInput) {
        qtyInput.value = String(moq);
        qtyInput.focus();
      }
    }
  }

  function initProductPage() {
    syncFromCurrentVariant(true);

    document.addEventListener('variant:update', function () {
      requestAnimationFrame(function () {
        syncFromCurrentVariant(true);
        setTimeout(function () {
          syncFromCurrentVariant(true);
        }, 50);
      });
    });

    document.addEventListener(
      'submit',
      function (event) {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
        if (!form.closest('product-form-component')) return;
        validateBeforeAdd(event);
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPage);
  } else {
    initProductPage();
  }
})();
